export {
  EventDecisionPanel,
  EventDecisionPanelView,
  // Re-exported for the M3 satellites: a satellite mounted into `children`
  // becomes a direct section of the panel card, so it opts into the same
  // 1px `--border` bottom rule rather than re-deriving it (WEB-738).
  PANEL_SECTION_CLASS,
} from './EventDecisionPanel';
export type { EventDecisionPanelProps, EventDecisionPanelViewProps } from './EventDecisionPanel';
export { EventDecisionBar, EventDecisionBarView } from './EventDecisionBar';
export type {
  EventDecisionBarProps,
  EventDecisionBarVariant,
  EventDecisionBarViewProps,
} from './EventDecisionBar';
